import { RootState, useAppDispatch, useAppSelector } from "../../redux/AppStore";
import { updateCustomerName } from "../../redux/slice/UpdateTrackingAddressSlice";

export default function CustomerNameComponent () {
 const dispatch = useAppDispatch();
const customername:string = useAppSelector((state: RootState) => state.updateAddress.newuserData.shipment_customer_name);
    return (
        <div className="UpdateVerifyInput">
        <label>Contact Name</label>
        <input type="text" className="form-control" placeholder="Contact Name" value={customername}  onChange={e => 
        {
        
            dispatch(
              updateCustomerName(e.target.value),
              );
        }
        } />
      </div>
    );
}